import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

export default class extends Controller {
  static get targets() { return ["list", "panel"]; }
  static get values() { return { url: String }; }

  // jQuery UI announces a finished drag through its own widget callback, which no
  // addEventListener - and therefore no data-action - can see.
  connect() {
    $(this.listTarget).sortable({
      // Only the .panel-heading child elements support dragging; omit this to make the
      // entire <li>...</li> draggable.
      handle: ".panel-heading",
      update: () => this.persist(),
    });
  }

  disconnect() {
    if (this.hasListTarget) { $(this.listTarget).sortable("destroy"); }
  }

  persist() {
    // jQuery's .data() coerced these to numbers; dataset does not, and the ids reach raw SQL.
    const order = this.panelTargets.map(panel => Number(panel.dataset.collectionTagId));

    const options = RequestHelper.defaultPostOptions();
    options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
    options.body = JSON.stringify({ order: order });

    fetch(this.urlValue, options).
      then(response => {
        if (!response.ok) { throw new Error(`Category order update failed (${response.status})`); }
      }).
      catch(response => console.warn("Unable to update collection category order: ", response));
  }
}
